var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 18,
    viewBox: "0 0 29 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.0269,
    y: 2.51129,
    width: 7.50872,
    height: 13.351,
    fill: "#FF5F00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5036 9.18679C11.5036 6.47413 12.7908 4.06812 14.7693 2.51129C13.3152 1.37905 11.4797 0.694991 9.47739 0.694991C4.73379 0.694991 0.895996 4.49271 0.895996 9.18679C0.895996 13.8809 4.73379 17.6786 9.47739 17.6786C11.4797 17.6786 13.3152 16.9945 14.7693 15.8623C12.7908 14.3291 11.5036 11.8995 11.5036 9.18679Z",
    fill: "#EB001B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6667 9.18679C28.6667 13.8809 24.8289 17.6786 20.0853 17.6786C18.083 17.6786 16.2475 16.9945 14.7935 15.8623C16.7958 14.3055 18.0592 11.8995 18.0592 9.18679C18.0592 6.47413 16.7719 4.06812 14.7935 2.51129C16.2475 1.37905 18.083 0.694991 20.0853 0.694991C24.8289 0.694991 28.6667 4.5163 28.6667 9.18679Z",
    fill: "#F79E1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMc);
export default __webpack_public_path__ + "static/media/mc.38de13154dbb377d1634b6ca95db7418.svg";
export { ForwardRef as ReactComponent };